import type React from 'react'

import bem from '#/bem'
import AccountMenu from '#/components/header/accountMenu'
import MainHeaderBase from '#/components/header/mainHeaderBase.component'
import MainHeaderLogo from '#/components/header/mainHeaderLogo.component'
import profileStore from '#/stores/profile'

interface BasicLayoutProps {
  children: React.ReactNode
}

/**
 * This is a base component that accepts any children. It has the minimum root
 * layout elements: Main header and place underneath it for content.
 *
 * Providers are not its business: the route blockers that use it render inside `App`'s provider tree
 * (see `app.jsx`).
 */
export default function BasicLayout(props: BasicLayoutProps) {
  return (
    <>
      <div className='header-stretch-bg' />

      <bem.PageWrapper className='mdl-layout mdl-layout--fixed-header'>
        <MainHeaderBase>
          <MainHeaderLogo />
          {profileStore.isLoggedIn && <AccountMenu />}
        </MainHeaderBase>

        <bem.PageWrapper__content className='mdl-layout__content'>{props.children}</bem.PageWrapper__content>
      </bem.PageWrapper>
    </>
  )
}
